<template>
    <div class="view-container">
      <div class="profile_form">
        <form v-if="user.id != null" name="Profile" :data-id="user.id">
            <label>First name</label><br>
            <input name="FirstName" type="text" class="form-control" placeholder="John Doe" :value="user.firstName">
            <label>Last name</label><br>
            <input name="LastName" type="text" class="form-control" placeholder="John Doe" :value="user.lastName">
            <label>Contact number</label>
            <input name="MobileNo" type="text" class="form-control" placeholder="012 345 6789" :value="user.mobileNo">
            <label>Email</label>
            <input name="EmailAddress" type="text" class="form-control" placeholder="johndoe@gmail.com" :value="user.emailAddress">
            <label>Address</label>
            <textarea name="Address" type="text" class="form-control" placeholder="What is the delivery street address" rows="3" v-model="user.address"></textarea>
            <label>Province</label>
            <input name="Province" type="text" placeholder="Enter the province or state" class="form-control" :value="user.province">
            <label>Country</label>
            <input name="Country" type="text" placeholder="Enter the country" class="form-control" :value="user.country">
            <label>Area / Postal code</label>
            <input name="AreaCode" type="text" placeholder="Enter Zip / Area code" class="form-control" :value="user.areaCode">

            <div class="profile_submit" :style="{ 'background-color': accentColor }">
                Save
            </div>
            <div class="password_change" :style="{ 'background-color': accentColor }">
                Change Password
            </div>
            <router-link to="history">
                <p  style="color:#275a86">I want to see my order history</p>
            </router-link>
        </form>
    </div>
  </div>
</template>
<!-- Scripts -->
<script>
import { view } from "./Profile.vue.js";
export default {
  name: "Profile",
  components: {
  },
  mixins: [view],
  data() {
    return {
      user: {}
    }
  },
  computed: {
      accentColor: function () {
        return this.$franchiseAccentColor;
      }
  },
  created() {
    if(localStorage.userMembershipID == null){
      this.$router.push({ path: 'Login', query: { returnUrl: "Profile" }});
    }
  },
  mounted() {
    var _self = this;
    var data = {
        FranchiseID: localStorage.franchiseID,
        MembershipUserID: localStorage.userMembershipID
    }
    _self.$ooApi.orders.accounts.get.v1(data).then(function(result){
        _self.user = result.data;
    }).then(function(){
          document.querySelector('.profile_submit').addEventListener("click", _self.submit);
          document.querySelector('.password_change').addEventListener("click", _self.changePassword);
    })
  }
};
</script>
<style scoped>
    @import './Profile.vue.css'; 
</style>
